// extracted by mini-css-extract-plugin
export default {"companies-container":"Companies_companies-container__K8kza"};